<template lang="html">
  <d-card class="card-small mb-4">
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" lg="4">
          <h6 class="m-0">Tabelas de Preço</h6>
        </d-col>
      </d-row>
    </d-card-header>

    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row v-if="priceTypes.length">
          <d-col md="12">
            <ul class="options" >
              <li v-for="(priceType, index) in priceTypes" :key="index" class="label-pill">
                <span class="label delete" @click.prevent="removePriceType(priceType)">
                  <i class="material-icons">delete</i>
                </span>
                <span class="label">{{ priceType.name }}</span>
              </li>
              <li class="label-pill" @click="openAddPriceType">+ Incluir Tabela</li>
            </ul>
          </d-col>
        </d-row>
        <d-row v-else>
          <d-col class="no-content">
            <p class=" m-0 no-content mb-3 col">Ainda não há tabelas de preço incluídas.</p>
            <span class="label-pill" @click="openAddPriceType">+ Incluir Tabela</span>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>

    <add-price-type-modal />
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_PRICE_TYPE_ } from './ProductModel';
import AddPriceTypeModal from './modal/AddPriceTypeModal.vue';

const modalAddPriceType = 'add_price_type_modal';

export default {
  name: 'product-price-types',
  components: {
    AddPriceTypeModal,
  },
  computed: {
    priceTypes() {
      const { product } = this.$store.state.product;
      return product.price_names.length ? product.price_names : [];
    },
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    removePriceType(priceType) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_PRICE_TYPE_, priceType);
    },
    openAddPriceType() {
      this.setToggle({ type: modalAddPriceType, bool: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.options {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  margin-bottom: 0;
  padding-left: 0;
  gap: 5px;
}
</style>
